import type { ComponentType, SVGProps } from 'react';
import type { MaintenanceQuoteConsentStatus } from './types/quote-centric';
import { IconClose, IconCheck2, IconPending } from '@belong/icons';

export const QUOTE_APPROVAL_STATUS_STYLES: Record<
  Exclude<MaintenanceQuoteConsentStatus, 'NotRequired'>,
  {
    label: (party?: string) => string;
    className: string;
    Icon: ComponentType<SVGProps<SVGSVGElement>>;
  }
> = {
  Approved: {
    label: (p) => (p ? `Approved By ${p}` : 'Approved'),
    className: 'text-green',
    Icon: IconCheck2,
  },
  Rejected: {
    label: (p) => (p ? `Rejected By ${p}` : 'Rejected'),
    className: 'text-dark-gray',
    Icon: IconClose,
  },
  Required: {
    label: (p) => (p ? `Pending Approval By ${p}` : 'Pending Approval'),
    className: 'text-red',
    Icon: IconPending,
  },
};

export const URL_QUERY_PARAMS = {
  TOAST_VISIBLE: 'toast-visible',
  SUCCESS: 'success',
  CREATION: 'creation',
  UPDATE: 'update',
  TURN_OFF: 'turn-off',
  UPDATE_FREQUENCY: 'update-frequency',
  NEXT_ON: 'next-on',
  CANCEL: 'cancel',
  TASK: 'task',
  UNIT_ID: 'unit-id',
  OUTCOME: 'outcome',
};

export const API_ERRORS = {
  APPOINTMENT_TOO_SOON: 'APPOINTMENT_TOO_SOON',
};
